import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Globals } from 'src/app/service/global';
import { MomService } from 'src/app/service/mom.service';
import { environment_const } from 'src/environments/environment';

@Component({
  selector: 'app-view-mom-dialog',
  templateUrl: './view-mom-dialog.component.html',
  styleUrls: ['./view-mom-dialog.component.css']
})
export class ViewMomDialogComponent implements OnInit {
  showLoading = false;
  meetingData:any;
  momList:any;
  curMomInfo:any;
  selectedValue:any
  constructor(@Inject(MAT_DIALOG_DATA) dialogData: any,public momService:MomService,private globals:Globals,private matDialogRef:MatDialogRef<ViewMomDialogComponent>) { 
    this.meetingData = dialogData.meetingInfo;
  }

  ngOnInit(): void {
    this.ViewMomPdfList(this.meetingData);
  }

  ViewMomPdfList(meetingInfoData:any){
 
    var minuteJSON = {
        //"meetingId": meetingInfoData.meetingId,
        //"pkMomDetailId":,
        "momStatus": environment_const.momApproveStatus,
        "userId":Number(this.globals.userId),
        "reportedUsersId": this.globals.userId+","+this.globals.repotingUsers,
        "fkMeetingEntityId": meetingInfoData.meetingId
      };
    this.showLoading=true;
 
    this.momService.fetchMoMSentList(minuteJSON).subscribe((response:any)=>{
      this.momList=response.body;
      if(this.momList!=null && this.momList!=undefined && this.momList.length>0){
        this.selectedValue = this.momList[0].pkMomDetailId;
        this.curMomInfo=this.momList[0];
        this.viewMomPdf();
      }
    }).add(()=>{
      this.showLoading=false;
    });
  }

  viewMomPdf(){
    var mom = this.curMomInfo;
 
    var minuteJSON = {
        //"meetingId": mom.fkMeetingEntityId,
        "pkMomDetailId":mom.pkMomDetailId,
        "momStatus": environment_const.momApproveStatus,
        "userId":this.globals.userId,
        "reportedUsersId": this.globals.userId+","+this.globals.repotingUsers,
        "fkMeetingEntityId": mom.meetingId
      };
    this.showLoading=true;
    this.momService.viewMoM(minuteJSON).subscribe((response:any)=>{
      let file = new Blob([response], { type: 'application/pdf' });            
      var blobUrl = URL.createObjectURL(file);
      window.open(blobUrl);
      if(this.momList!=null && this.momList!=undefined && this.momList.length==1){
        this.matDialogRef.close();
      }
      //$("#viewMinutes").attr("src",blobUrl);
    }).add(()=>{
      this.showLoading=false;
    });
  }

  setCurrentMomInfo(mom:any){
    this.curMomInfo=mom;
  }
 

}
